// extracted by mini-css-extract-plugin
export default {"emptyTable":"emptyTable_emptyTable__+hoye","emptyTableImg":"emptyTable_emptyTableImg__+j8cN","emptyTableImgPartner":"emptyTable_emptyTableImgPartner__LstHA"};